import Repository from "./Repository";

const getErrorCodes = "admin/errorcodes/get";
const addErrorCodes = "admin/errorcodes/add";
const editErrorCodes = "admin/errorcodes/edit";
const removeErrorCodes = "admin/errorcodes/remove";

export default {
    getErrorCodes(payload) {
    return Repository.post(`${getErrorCodes}`, payload);
    },
    addErrorCodes(payload) {
    return Repository.post(`${addErrorCodes}`, payload);
    },
    editErrorCodes(payload) {
    return Repository.post(`${editErrorCodes}`, payload);
    },
    removeErrorCodes(payload) {
    return Repository.post(`${removeErrorCodes}`, payload);
    },
}